<div class="admin-modal-header">

  <div class="modal-header-icon">
    <img ngSrc="{{'assets/images/icons/' + iconName + '.svg' }}"
         alt="icon {{iconName}}"
         height="32"
         width="32" *ngIf="!isDeleteModal">
    <img ngSrc="{{'assets/images/icons/error/trash.svg' }}"
         alt="icon trash"
         height="32"
         width="32" *ngIf="isDeleteModal">
  </div>

  <div class="modal-header-title">{{ title }}</div>

  <div class="modal-header-subtitle" *ngIf="subtitle">{{ subtitle }}</div>

</div>
